<template>
<div class="container" id="container-chat" v-if="!isShowViolation && !isShowMemo && !isShowDetail" style="height: 100vh; overflow: scroll;">
<header >
    <span v-if="userInfo">{{ userInfo.display_name }}</span>
    <div class="h-left">
        <a @click="redirectBack()"><img src="~@/assets/images/icon02.svg" /></a>
    </div>
    <div class="h-right">
        <a @click="isShowPopup = true"><img src="~@/assets/images/icon06.svg" /></a>
    </div>
    <div class="chat-img" v-if="userInfo">
        <a @click="openDetail"><img :src="getImageUrl(userInfo.avatar_url)" /></a>
    </div>
</header>
<div id="wrap2" v-if="pointSetting">
    <div class="chat-bc">
        <div class="chat-first" v-if="isCloseText">
            <p class="chat-first-close" @click="isCloseText = false">
                <a><i class="fas fa-times-circle"></i></a>
            </p>
            1通目のメッセージでメールアドレス・LINE ID・カカオ
            ID・Facebookのアカウントやその他のSNSのID、携帯電話番号などあなたを特定できる個人情報は送信できません。<br />
            ※健全なサービスを運営する目的で運営者がメッセージの内容を確認・削除（悪質な場合は強制退会）する場合があります。これに同意した上で送信してください。
        </div>
        <infinite-loading v-if="!isApproveFirstMessage || checkApproveFirstMessage()" direction="top" @infinite="scrollMessage" spinner="spiral" :identifier="infiniteId">
            <template v-slot:no-more></template>
            <template v-slot:no-results>
                <div id="wrap3">
                    <div id="middle"></div>
                </div>
            </template>
        </infinite-loading>
        <div v-for="(item, index) in messages" :key="index">
            {{ userDetail.name }}
            <div v-if="parseInt(item.u_id) === parseInt(userId)">
                <div :class="
              !checkVery()
                ? 'balloon area'
                : 'balloon'
            ">
                    <a v-if="!checkVery()">
                        <div class="browsing" @click="redirectVery">
                            閲覧する場合はこちらをタップしてください。
                        </div>
                    </a>
                    <div class="faceicon" v-if="userInfo">
                        <img :src="getImageUrl(userInfo.avatar_url)" @click="$router.push({ name: 'userDetail', query: { id: userInfo.id } })" />
                    </div>
                    <div :class="!checkVery()? 'blur': ''" @click="redirectVery">
                        <div class="chatting" v-if="item.type == 'text'">
                            <div class="says">
                                <p>
                                    {{ item.msg }}
                                </p>
                            </div>
                        </div>
                        <div class="chatting" v-if="item.type == 'gift'">
                            <div class="says">
                                <p><img style="width: 35vw; max-height: 100px;"  :src="getImageUrl(getGift(item.param.gift_id).image_show)" /></p>
                            </div>
                            <span v-html="getMessageGift(item, getGift(item.param.gift_id))"></span>
                        </div>
                        <div class="chatting" v-if="item.type == 'image'">
                            <div class="says">
                                <p><img @click="openImage(item)" style="width: 35vw; max-height: 100px; object-fit: cover;" :src="getImageUrl(item.path)" /></p>
                            </div>
                        </div>
                        <div class="chatting" v-if="item.type == 'location'">
                            <div class="says" style="width: 40%; display:block">
                                <p style="height: 100px; width: 100%">

                                    <GMapMap :center="{
                        lat: +item.param.lat,
                        lng: +item.param.long
                      }" :zoom="10 " map-type-id="terrain" style="width: 100vw; height: 20rem">
                                        <GMapMarker :position="{
                          lat: +item.param.lat,
                          lng: +item.param.long
                        }" :clickable="true" :draggable="true" />
                                    </GMapMap>
                                </p>
                            </div>
                        </div>
                        <!-- Show call -->
                        <div class="chatting opponent_call_items" v-if="item.type == 'call'">
                            <!-- Video -->
                            <div v-if="item.supports_video == constants.SUPPORTS_VIDEO">
                                <div class="says" v-if="item.msg_status == constants.CALL_STATUS.DONE">
                                    <p><img src="~@/assets/images/call/video_call_established.png" /></p>
                                </div>
                                <div class="says" v-if="item.msg_status == constants.CALL_STATUS.DENIED">
                                    <p><img src="~@/assets/images/call/video_call_not_established.png" /></p>
                                </div>
                                <div class="says" v-if="item.msg_status == constants.CALL_STATUS.CANCEL">
                                    <p><img src="~@/assets/images/call/video_call_cancel.png" /></p>
                                    <label>キャンセル</label>
                                </div>
                            </div>

                            <!-- Audio -->
                            <div v-else>
                                <div class="says" v-if="item.msg_status == constants.CALL_STATUS.DONE">
                                    <p><img src="~@/assets/images/call/voice_call_established.png" /></p>
                                </div>
                                <div class="says" v-if="item.msg_status == constants.CALL_STATUS.DENIED">
                                    <p><img src="~@/assets/images/call/voice_call_not_established.png" /></p>
                                </div>
                                <div class="says" v-if="item.msg_status == constants.CALL_STATUS.CANCEL">
                                    <p><img src="~@/assets/images/call/voice_call_cancel.png" /></p>
                                </div>
                            </div>
                        </div>
                        <p v-if="item.time" class="chat-time">{{ formatDateTime3(item.time) }}</p>
                    </div>
                </div>
            </div>
            <!-- my chat -->
            <div v-if="parseInt(item.u_id) === parseInt(userDetail.id)">
                <!-- Show text -->
                <div v-if="item.type == 'text'">
                    <div class="mycomment">
                        <p>
                            {{ item.msg }}
                        </p>
                    </div>
                </div>
                <!-- Show gift -->
                <div v-if="item.type == 'gift'">
                    <div class="mycomment">
                        <p><img style="width: 35vw; max-height: 100px;"  :src="getImageUrl(getGift(item.param.gift_id).image_show)" /></p>
                        <span v-html="getMessageGift(item, getGift(item.param.gift_id))"></span>
                    </div>
                </div>
                <div v-if="item.type == 'image'">
                    <div class="mycomment">
                        <p @click="openImage(item)"><img style="width: 35vw; max-height: 100px; object-fit: cover;"  :src="getImageUrl(item.path)" /></p>
                    </div>
                </div>
                <!-- Show location -->
                <div v-if="(item.type === 'location')" class="mycomment">
                    <p style="height: 100px; width: 40%">
                        <GMapMap :center="{
                  lat: +item.param.lat,
                  lng: +item.param.long
                }" :zoom="10 " map-type-id="terrain" style="width: 100vw; height: 20rem">
                            <GMapMarker :position="{
                    lat: +item.param.lat,
                    lng: +item.param.long
                  }" :clickable="true" :draggable="true" />
                        </GMapMap>
                    </p>
                </div>
                <!-- Show call -->
                <div class="my_call_items" v-if="item.type == 'call'">
                    <!-- Video -->
                    <div v-if="item.supports_video == constants.SUPPORTS_VIDEO">
                        <div class="mycomment" v-if="item.msg_status == constants.CALL_STATUS.DONE">
                            <p><img src="~@/assets/images/call/video_call_established.png" /></p>
                        </div>
                        <div class="mycomment" v-if="item.msg_status == constants.CALL_STATUS.DENIED">
                            <p><img src="~@/assets/images/call/video_call_not_established.png" /></p>
                        </div>
                        <div class="mycomment" v-if="item.msg_status == constants.CALL_STATUS.CANCEL">
                            <p>
                                <img src="~@/assets/images/call/video_call_cancel.png" />
                                <br>
                                <label>キャンセル</label>
                            </p>
                        </div>
                    </div>

                    <!-- Audio -->
                    <div v-else>
                        <div class="mycomment" v-if="item.msg_status == constants.CALL_STATUS.DONE">
                            <p><img src="~@/assets/images/call/voice_call_established.png" /></p>
                        </div>
                        <div class="mycomment" v-if="item.msg_status == constants.CALL_STATUS.DENIED">
                            <p><img src="~@/assets/images/call/voice_call_not_established.png" /></p>
                        </div>
                        <div class="mycomment" v-if="item.msg_status == constants.CALL_STATUS.CANCEL">
                            <p>
                                <img src="~@/assets/images/call/voice_call_cancel.png" />
                                <label>キャンセル</label>
                            </p>

                        </div>
                    </div>
                </div>
                <p v-if="item.time" class="chat-time2">{{ formatDateTime3(item.time) }}</p>
                <div class="alert-first-message" v-if="!checkApproveFirstMessage() && messages.length > 0">
                    <div>文言の審査中です。</div>
                    <div>承認後に送信されます。</div>
                </div>
            </div>
        </div>
    </div>
</div>

<div id="chat" style="z-index: 99999; position: fixed; bottom: 0; right: 0; left: 0">
    <div class="chat" style="overflow: auto">
        <div class="message-action">
            <div v-if="isOpen === false">
                <a @click="isOpen = true"><img src="~@/assets/images/icon07.svg" /></a>
            </div>
            <div v-if="isOpen === true">
                <a @click="isOpen = false"><img src="~@/assets/images/icon08.svg" /></a>
            </div>
            <textarea 
                placeholder="メッセージを送信する" 
                name="body" 
                id="chatInput"
                rows="1" 
                cols="1" 
                class="chat2" 
                style="min-height: 34px; max-height: 80px; margin-right: 6px"
                v-model="message" 
                :disabled="!checkApproveFirstMessage() && getMyMessage().length > 0 ? true : false" 
                @keyup="typingMessage"></textarea>
            <!-- <input type="submit" @click="submit" src="~@/assets/images/sub.svg" class="chat3" /><br /> -->
            <button :disable="message ? false:  true" :class="message ? 'btn-submit' : 'btn-disable'" @click="submit">送信</button>
        </div>
        <div v-if="isOpen === true &&  (checkApproveFirstMessage() || (!checkApproveFirstMessage() || getMyMessage().length === 0))">
            <ul class="chat4 clearfix">
                <li @click="sendLocation">
                    <img src="~@/assets/images/chat-icon01.png" />
                </li>
                <li @click="sendImage"><img src="~@/assets/images/chat-icon02.png" /></li>
                <li @click="callAudio"><img src="~@/assets/images/chat-icon07.png" /></li>
                <li @click="callVideo" v-if="parseInt(userDetail.sex) === constants.MALE"><img src="~@/assets/images/chat-icon04.png" /></li>
                <li v-if="parseInt(userDetail.sex) === constants.MALE"><img src="~@/assets/images/chat-icon05.png" /></li>
            </ul>
            <input type="file" hidden id="file" accept="image/png, image/jpeg, image/jpg,  image/gift" />
            <ul class="chat5 clearfix" v-if="parseInt(userDetail.sex) == constants.MALE">
                <li v-for="item in pointSetting.gifts.result" :key="item.id" @click="sendGift(item.id)">
                    <img :src="getImageUrl(item.image)" />
                </li>
            </ul>
        </div>
    </div>
</div>
</div>
<!-- Show user profile -->
<div id="detail" class="hidden-user">
    <detail v-if="isShowDetail" :idUser="userInfo.id" @close="closeDetail"></detail>
</div>
<basic-dialog :active="isShowPopup">
    <div class="flex-row">
        <button class="btn-start" @click="favorite">
            {{ parseInt(userInfo.favorite_status) === IS_FAVORITE ? 'お気に入り解除' : 'お気に入りに追加' }}
        </button>
        <button @click="isShowViolation = true; isShowPopup = false">
            違反報告する
        </button>
        <button @click="lock">
            プロックする
        </button>
        <button  class="btn-end" @click="openMemo">メモ</button>
        <button class="btn-close" @click="isShowPopup = false">
            キャンセル
        </button>
    </div>
</basic-dialog>
<!-- <basic-dialog :active="isFavoriteSuccess || isLockSuccess">
    <div class="favorite-message">
        {{ messageFavorite ? messageFavorite : messageLock }}
    </div>
</basic-dialog> -->
<violation v-if="metadata && userDetail" :userDetail="userInfo" :isShow="isShowViolation" :report-categories="metadata.report_categories" @closeReport="closeReport"></violation>
<createMemo  :isShow="isShowMemo"  @submit="submitMemo" :userInfo="userInfo" @closeMemo="closeMemo"></createMemo>
<!-- <openImage :active="isShowImage" @close="closeImage">
    <img style="width:100%" :src="getImageUrl(imageOpen)" />
</openImage> -->
<imageShow :active="isShowImage">
    <div>
        <img :src="getImageUrl(imageOpen)"  style="width: 100%;" id="popupImage">
    </div>
</imageShow>
<div class="loading-screen" style="opacity: 0.8" v-if="isLoading">
    <div class="loader"></div>
</div>
<successDialog :active="isShowAlertApproveFM" @close="isShowAlertApproveFM = false">
    <template v-slot:message>
        {{ alertApproveFM }}
    </template>
</successDialog>

<alertDialogBottom :active="isAlertMemo">
    メモを保存しました。
</alertDialogBottom>

<alertDialogBottom :active="isFavoriteSuccess || isLockSuccess">
    {{ messageFavorite ? messageFavorite : messageLock }}
</alertDialogBottom>
<!-- Subscription -->
<subscriptionAlert :active="isShowAlertSubscription">
    <div class="subscription">
        <div class="title">有料会員の登録が必要です</div>
        <div class="content">簡単ステップで<br>有料会員の登録を済ませましょう</div>
        <div class="btn1" @click="openSubscription()">詳しく見る</div>
    </div>
</subscriptionAlert>
<!-- Verify age -->
<subscriptionAlert :active="isShowAlertVerifyAge">
    <div class="subscription">
        <div class="title">年齢認証が必要です</div>
        <div class="content">
            <h3>簡単ステップで<br>年齢確認を済ませましょう。</h3>
            <br>
            お相手とのメッセージを行うためには<br>法令により年齢確認が必要となります。
        </div>
        <div class="btn1" @click="openVerifyAge()">詳しく見る</div>
    </div>
</subscriptionAlert>
<div id="subscription" class="hidden-right">
    <subscription :isShow="true" @close="closeSubscription"></subscription>
</div>
<div id="very-age" class="hidden-right">
    <veryAge :isShow="true" @close="closeVerifyAge"></veryAge>
</div>
</template>

<script>
import {
    Skeletor
} from "vue-skeletor"
import "vue-skeletor/dist/vue-skeletor.css"
import {
    mapGetters,
    mapActions
} from "vuex"
import CONSTANTS from "@/constants"
import mixin from "@/mixin"
import openImage from "@/views/components/openImage"
import BasicDialog from "../user/components/basicDialog";
import violation from "../user/components/violation"
import createMemo from "../profile/components/createMemo"
import successDialog from '@/views/components/successDialog'
import detail from "../user/detail"
import alertDialogBottom from "@/views/components/alertDialogBottom.vue";
import imageShow from "../user/components/imageShow"
import subscriptionAlert from "@/views/user/components/subscriptionAlert"
import veryAge from '../profile/veryAge'
import subscription from '../profile/subscription'
export default {
    name: 'chat',
    props: {
        idUser: String,
        codeUser: String
    },
    emits: ['close'],
    mixins: [mixin],
    components: {
        openImage,
        BasicDialog,
        violation,
        createMemo,
        successDialog,
        detail,
        imageShow,
        alertDialogBottom,
        subscriptionAlert,
        veryAge,
        subscription
    },
    data: () => ({
        imageOpen: null,
        isShowImage: false,
        pointSetting: null,
        template: null,
        loading: false,
        userInfo: null,
        pageSize: 20,
        IS_SUBSCRIPTION: CONSTANTS.IS_SUBSCRIPTION,
        pageCurrent: 0,
        isOpen: false,
        message: null,
        messageList: [],
        user: null,
        userSelfId: null,
        isApproveFirstMessage: false,
        isCloseText: true,
        messageImages: [],
        mesageImages: [],
        constants: CONSTANTS,
        isGetTemplate: false,
        isShowViolation: false,
        isShowPopup: false,
        messageLock: null,
        isFavoriteSuccess: false,
        messageFavorite: null,
        isLockSuccess: false,
        IS_FAVORITE: CONSTANTS.IS_FAVORITE,
        isShowMemo: false,
        isLoading: false,
        infiniteId: +new Date(),
        noResult: 'メッセージなし',
        isShowAlertApproveFM: false,
        alertApproveFM: '',
        isShowDetail: false,
        isAlertMemo: false,
        msg_temp: null,
        isShowAlertVerifyAge: false,
        isShowAlertProcessApprove: false,
        MALE: CONSTANTS.MALE,
        FEMALE: CONSTANTS.FEMALE,
        isShowAlertSubscription: false,
        isShowAlertVerifyAge: false,
        isFirstLoadMessage: true
    }),
    async mounted() {
        this.getPointFee();
        this.getUserDetail();
        if (!this.socketClient) {
            this.$store.dispatch('socket/initState')
        }
        this.readMessage()
        this.autoResizeTextArea()
        this.outSideClick()
        if (this.sockets) {
            this.sockets.subscribe("server-chat-send-ok", async (data) => {
                if (data.u_id == this.userDetail.id) {
                    this.msg_temp = data
                    this.msg_temp.is_sent = true;
                    setTimeout(() => {
                        document.getElementById('container-chat').scrollTo(
                            0, document.getElementById('container-chat').scrollHeight + 500
                        );
                    }, 100)
                }
            });
            this.sockets.subscribe("server-chat-receive", async (data) => {
                this.msg_temp = data
                setTimeout(() => {
                    document.getElementById('container-chat').scrollTo(
                        0, document.getElementById('container-chat').scrollHeight + 500
                    );
                }, 1000)
            });
        }

    },
    computed: {
        ...mapGetters(["metadata", "defaultToken", "messages", "socketClient", "userDetail"]),
        userId() {
            if (this.idUser) {
                return this.idUser
            }
            return this.$route.query.user_id;
        },

        userCode() {
            if (this.codeUser) {
                return this.codeUser
            }
            return this.$route.query.user_code;
        },

    },
    watch: {
        isShowDetail(val) {
            const body = document.getElementById('chat');
            if (val) body.style.overflow = "hidden";
            else body.style.overflow = "auto";
        },
        isShowViolation(val) {
            const body = document.getElementById('chat');
            if (val) body.style.overflow = "hidden";
            else body.style.overflow = "auto";
        },
    },
    methods: {
        ...mapActions({
            getDefaultToken: "user/getDefaultToken",
            setMessage: "message/setMessage",
            setCurrentUser: "socket/setCurrentUser",
            setupSocketChattingEvent: "socket/setupSocketChattingEvent",
            setFooter: "layout/setFooter"
        }),
        checkVery() {
            if (parseInt(this.userDetail.sex) === CONSTANTS.MALE &&
            parseInt(this.userDetail.is_subscription) === CONSTANTS.IS_SUBSCRIPTION && 
            parseInt(this.userDetail.is_verify_age) === CONSTANTS.IS_VERY_AGE) {
                return true
            }
            if (parseInt(this.userDetail.sex) === CONSTANTS.FEMALE &&
            parseInt(this.userDetail.is_verify_age) === CONSTANTS.IS_VERY_AGE) {
                return true
            }
            return false
        },
        redirectVery() {
            let userDetail = this.userDetail
            if (userDetail && parseInt(userDetail.is_subscription) !== CONSTANTS.IS_SUBSCRIPTION && parseInt(userDetail.sex) === CONSTANTS.MALE) {
                this.isShowAlertSubscription = true
                return
            }
            if (userDetail && parseInt(userDetail.is_verify_age) === CONSTANTS.NO_VERY_AGE) {
                this.isShowAlertVerifyAge = true
                return
            }
            if (userDetail && parseInt(userDetail.is_verify_age) === CONSTANTS.PC_VERY_AGE) {
                this.isShowAlertProcessApprove = true
                return
            }

        },
        openDetail() {
            document.getElementById('detail').classList.add('show-user')
            document.getElementById('detail').classList.remove('hidden-user')
            this.isShowDetail = true
        },
       
        closeDetail() {
            document.getElementById('detail').classList.remove('show-user')
            document.getElementById('detail').classList.add('hidden-user')
            this.isShowDetail = false
        },
        callAudio() {
            if (!this.checkVery()) {
                this.redirectVery()
                return
            }
            if (!this.checkApproveFirstMessage() && this.getMyMessage().length > 0 || this.messages.length === 0) {
                this.isShowAlertApproveFM = true
                this.alertApproveFM = 'メッセージ送信後に、通話が可能になります';
                return
            }
            this.$store.dispatch('call/call_audio', {r_id: this.idUser, pointSetting: this.pointSetting, avatar_url:this.getImageUrl(this.userInfo.avatar_url)})

        },
        callVideo() {
            if (!this.checkVery()) {
                this.redirectVery()
                return
            }
            if (!this.checkApproveFirstMessage() && this.getMyMessage().length > 0 || this.messages.length === 0) {
                this.isShowAlertApproveFM = true
                this.alertApproveFM = 'メッセージ送信後に、通話が可能になります';
                return
            }
            this.$store.dispatch('call/call_video', {r_id: this.idUser, pointSetting: this.pointSetting, avatar_url:this.getImageUrl(this.userInfo.avatar_url)})
        },
        redirectBack() {
            this.isFirstLoadMessage = true
            this.setMessage([])
            if (this.idUser) {
                if (!this.checkApproveFirstMessage() && this.messages.length > 0) {
                    this.$emit('close')
                } else {
                    this.$emit('close', this.msg_temp)
                }
                
            } else {
                this.$router.go(-1)
            }
        },
        openMemo() {
            this.isShowMemo = true
            this.isShowPopup = false
        },
        closeImage() {
            this.isShowImage = false
        },
        closeReport() {
            this.isShowViolation = false
        },
        closeMemo() {
            this.isShowMemo = false
        },
        openImage(item) {
            if (!this.checkVery()) {
                this.redirectVery()
                return
            }
            this.imageOpen = item.path
            this.isShowImage = true
            document.addEventListener("click", (evt) => {
                const flyoutElement = document.getElementById("popupImage");
                let targetElement = evt.target; // clicked element
                do {
                    if (targetElement == flyoutElement) {

                        return;
                    }
                    targetElement = targetElement.parentNode;
                } while (targetElement);
                const wrap = document.querySelector(".wrap");
                if (wrap == evt.target) {
                    this.isShowImage = false
                }
            });
        },
        typingMessage() {
            this.$store.dispatch('socket/typingMessage', {
                user_id: this.userId
            })
        },
        readMessage() {
            const date = new Date();
            this.$store.dispatch('socket/receiveMessage', {
                time: date.getFullYear() + '/' + (date.getMonth() + 1) + '/' + date.getDate() + ' ' + date.getHours() + ':' + date.getMinutes(),
                user_id: this.userId
            })
        },
        sendLocation() {
            if (!this.checkVery()) {
                this.redirectVery()
                return
            }
            if (!this.checkApproveFirstMessage() && this.getMyMessage().length > 0 || this.messages.length === 0) {
                this.isShowAlertApproveFM = true
                this.alertApproveFM = 'メッセージ送信後に、GPSの送信が可能になります';
                return
            }
            let geolocation = navigator.geolocation;
            if (geolocation) {
                // Có hỗ trợ geolocation
            } else {
                // Không hỗ trợ geolocation
            }
            let options = {
                enableHighAccuracy: true,
                timeout: 5000,
                maximumAge: 0,
            };
            let result = null;
            this.isOpen = false
            geolocation.getCurrentPosition(
                (position) => {
                    const lat = position.coords.latitude;
                    const long = position.coords.longitude;
                    result = {
                        lat: lat,
                        long: long,
                    };
                    this.$store.dispatch("socket/sendLocation", {
                        location: result,
                        user_id: this.userId,
                    })
                },
                () => {
                    // error
                },
                options
            );
        },
        async getPointFee() {
            this.$store
                .dispatch("user/getPointFee", {
                    token: this.defaultToken,
                })
                .then((data) => {
                    this.pointSetting = data;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        getUserDetail() {
            this.$store
                .dispatch("user/userShow", {
                    id: this.userId,
                    token: this.defaultToken,
                })
                .then((data) => {
                    this.userInfo = data;
                })
                .catch((err) => {
                    console.log(err);
                });
        },

        async scrollMessage($state) {
            if (this.isOpen) return
            // if (this.messages.length > 0 && this.messages.length < this.pageSize && $state) {
            //     $state.complete()
            //     return
            // }
            let params = {
                id: this.userId,
                user_code: this.userCode,
                page: this.pageCurrent,
                limit: this.pageSize,
                token: this.defaultToken,
                seq: null
            }
            if (this.messages.length > 0) {
                params.seq = this.messages[0].msg_id
            }
            await this.$store
                .dispatch("message/getMessageHistory", params)
                .then(async (data) => {
                    if (data.result[0]) {
                        this.pageCurrent++;
                        
                        this.messageList.unshift(...data.result.reverse());
                        this.messageList.forEach((item, index) => {
                            if (item.type === 'image') {
                                this.getMedia(item.param.media_id, index)
                            }
                        })
                        this.setMessage(this.messageList)
                        // api return this.pageSize - 1 items
                        if (data.result.length < this.pageSize - 1) {
                            $state.complete();
                        } else {
                            $state.loaded();
                        }
                        $state.loaded();

                    } else {
                        if (this.messageList.length === 0) {
                             this.setMessage([])
                        }
                        $state.complete();
                    }
                    if (this.isFirstLoadMessage) {
                        setTimeout(() => {
                            document.getElementById('container-chat').scrollTo(
                                0,
                                document.getElementById('container-chat').scrollHeight + 500 || document.getElementById('container-chat').scrollHeight + 500
                            );
                        }, 1000)
                        this.isFirstLoadMessage = false
                    }
                    await this.getTemplateMessage();
                })
                .catch((err) => {
                    $state.complete();
                    console.log(err);
                });
            this.isLoading = false
        },
        async getTemplateMessage() {
            if (this.isGetTemplate) {
                return
            }
            await this.$store
                .dispatch("message/getMessageTemplate", {
                    token: this.defaultToken,
                })
                .then((data) => {
                    this.isGetTemplate = true
                    if (data[0]) {
                        this.template = data[0];
                        if (
                            parseInt(this.template.status) === CONSTANTS.IS_SUBSCRIPTION &&
                            !this.messageList[0]
                        ) {
                            this.message = this.template.body;
                        }
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        async submit() {
            if (!this.checkVery()) {
                this.redirectVery()
                return
            }
            if (this.message) {
                if (this.getMyMessage().length === 0) {
                    let formData = new FormData()
                    formData.append('receiver_id', this.userId)
                    formData.append('message', this.message)
                    formData.append('token', this.defaultToken)
                    await this.$store.dispatch('message/sendFirstMessage', formData).then(async data => {
                        let messageDetail = {
                            u_id: this.userSelfId,
                            r_id: this.userId,
                            is_first_message: "1",
                            msg: this.message,
                            type: "text",
                            time: new Date().getTime(),
                            is_cover: CONSTANTS.FIRST_MESSAGE_STATUS_APPROVING,
                        }
                        // this.messageList.push(messageDetail)
                        this.isApproveFirstMessage = true
                        await this.$store.dispatch("message/updateMessage", messageDetail)
                    })
                } else {
                    await this.$store.dispatch("socket/sendMessage", {
                        message: this.message,
                        user_id: this.userId,
                    });
                    if (this.messageList.length === 0) {
                        this.noResult = ""
                    }
                }
                this.msg_temp =  this.message
                this.message = null;
                document.querySelector("#chatInput").style.height = 'auto';
            }
        },
        getGift(id) {
            // if (!this.pointSetting) {
            //     await this.getPointFee();
            // }
            // console.log('point:', this.pointSetting)
            let gift = this.pointSetting.gifts.result.filter((item) => {
                return parseInt(item.id) === parseInt(id);
            });
            return gift[0];
        },
        getMessageGift(message, gift) {
            if (parseInt(message.u_id) === parseInt(this.userDetail.id)) {
                return gift.name + 'をプレゼントしました。'
            } else {
                return gift.name + 'がプレゼントされました！<br><div>プラス'+gift.received_point+'pt</div>'
            }
        },
        sendGift(giftId) {
            if (!this.checkVery()) {
                this.redirectVery()
                return
            }
            if (!this.checkApproveFirstMessage() && this.getMyMessage().length > 0 || this.messages.length === 0) {
                this.isShowAlertApproveFM = true
                this.alertApproveFM = 'メッセージ送信後に、プレゼント機能が使用できます';
                return
            }
            this.isOpen = false
            this.$store.dispatch('socket/sendGift', {
                gift_id: giftId,
                user_id: this.userId
            })
            // this.messageList.push({
            //   u_id: this.userSelfId,
            //   r_id: this.userId,
            //   type: "gift",
            //   param: {
            //     gift_id: giftId,
            //   }
            // })
        },
        sendImage() {
            if (!this.checkVery()) {
                this.redirectVery()
                return
            }
            if (!this.checkApproveFirstMessage() && this.getMyMessage().length > 0 || this.messages.length === 0) {
                this.isShowAlertApproveFM = true
                this.alertApproveFM = 'メッセージ送信後に、画像の送信が可能になります。';
                return
            }
            let fileInput = document.getElementById("file")
            fileInput.click()
            fileInput.addEventListener('change', async e => {
                let formData = new FormData()
                formData.append('token', this.defaultToken)
                formData.append('type', 1)
                formData.append('sector', 'chat')
                this.isOpen = false
                this.isLoading = true
                await this.downscaleImage(fileInput.files[0]).then(file => {
                    formData.append('file', file)
                    this.$store.dispatch('message/uploadImage', formData).then(data => {
                        this.$store.dispatch('socket/sendImage', {
                            file: {
                                media_id: data.media_id,
                                name_original: data.name,
                                size: data.size,
                                height: data.height,
                                width: data.width,
                                mime: data.mime
                            },
                            user_id: this.userId
                        }).then(() => {
                            setTimeout(() => {
                                document.getElementById('container-chat').scrollTo(
                                    0, document.getElementById('container-chat').scrollHeight + 500
                                );
                            }, 1000)
                        })
                    }).catch(err => {
                        console.log(err)
                    })
                })
                this.isLoading = false
            
            })
        },
        getMedia(id, index) {
            this.$store.dispatch('message/getMedia', {
                id: id,
                token: this.defaultToken,
                size: 'medium',
                thumbnail: true
            }).then(data => {
                this.messageList[index].path = data.path
            }).catch(err => {
                // rej(err)
            })
        },
        redirectUserDetail(id) {
            this.$router.push({
                name: 'userDetail',
                query: {
                    id: id
                }
            })
        },
        call_audio() {
            this.$store.dispatch('call/call_audio');
        },

        call_video() {
            this.$store.dispatch('call/call_video');
        },

        async favorite() {
            this.messageLock = null
            let type = null
            if (parseInt(this.userInfo.favorite_status) === CONSTANTS.IS_FAVORITE) {
                type = CONSTANTS.UN_FAVORITES_STATUS
            } else {
                type = CONSTANTS.FAVORITES_STATUS
            }
            // simulate AJAX

            if (type === CONSTANTS.UN_FAVORITES_STATUS) {
                let formData = new FormData()
                formData.append("token", this.defaultToken)
                formData.append("user_id", this.userId)
                await this.$store
                    .dispatch("user/sendUnFavorite", formData)
                    .then(() => {
                        this.isFavoriteSuccess = true
                        this.isShowPopup = false
                        this.userInfo.favorite_status = type
                        if (type === CONSTANTS.UN_FAVORITES_STATUS) {
                            this.messageFavorite = "お気に入りを解除しました"
                        } else {
                            this.messageFavorite = "お気に入りに追加しました"
                        }
                        setTimeout(() => {
                            this.isFavoriteSuccess = false
                        }, 1000)
                    })
                    .catch((err) => {
                        this.isShowPopup = false
                        console.log(err);
                    });
            } else {
                let formData = new FormData()
                formData.append("token", this.defaultToken)
                formData.append("favorites_user_code", this.userInfo.user_code)
                formData.append("favorites_id", this.userId)
                formData.append("type", type)

                await this.$store
                    .dispatch("user/sendFavorite", formData)
                    .then(() => {
                        this.isFavoriteSuccess = true
                        this.isShowPopup = false
                        this.userInfo.favorite_status = type
                        if (type === CONSTANTS.UN_FAVORITES_STATUS) {
                            this.messageFavorite = "お気に入りを解除しました"
                        } else {
                            this.messageFavorite = "お気に入りに追加しました"
                        }
                        setTimeout(() => {
                            this.isFavoriteSuccess = false
                        }, 1000)
                    })
                    .catch((err) => {
                        this.isShowPopup = false
                        console.log(err);
                    });
            }

        },

        async lock() {
            this.messageFavorite = null
            let formData = new FormData()
            formData.append("token", this.defaultToken)
            formData.append("id", this.userId)
            formData.append('lock_user_code', this.userInfo.user_code)
            formData.append('type', CONSTANTS.LOCK_STATUS)
            await this.$store
                .dispatch("user/lockUser", formData)
                .then(() => {
                    this.isLockSuccess = true
                    this.isShowPopup = false
                    this.messageLock = "ブロックしました。"
                    setTimeout(() => {
                        this.isLockSuccess = false
                    }, 1000)
                })
                .catch((err) => {
                    this.isShowPopup = false
                    console.log(err);
                });
        },
        async submitMemo(formData) {
            this.isLoading = true
            let form = new FormData()
            form.append('user_id', formData.userId)
            form.append('category', formData.categoryId)
            form.append('content', formData.content)
            form.append('token', this.defaultToken)
            await this.$store.dispatch('profile/createMemo', form).then(() => {
                this.isLoading = false
                this.isAlertMemo = true
                setTimeout(() => {
                    this.isAlertMemo = false
                }, 1000)

                this.isEdit = false
                // this.changeType(this.category)

            }).catch(() => {
                this.isEdit = false
            })
            this.isShowMemo = false
        },
        checkApproveFirstMessage() {
            // if (!this.user) return false
            if (this.messages.length === 0) {
                return false
            }
            if (this.messages.length > 0) {
                let isApprove = this.messages.filter(item =>{
                    return (parseInt(item.u_id) === parseInt(this.userDetail.id)) && 
                    parseInt(item.is_first_message) === CONSTANTS.FIRST_MESSAGE_STATUS_APPROVING &&
                    item.is_cover &&
                    parseInt(item.is_cover) === CONSTANTS.FIRST_MESSAGE_STATUS_APPROVING
                })
                if (isApprove[0]) {
                    return false
                } else {
                    this.isApproveFirstMessage = true
                    // console.log('approve: ', isApprove)
                    return true
                }
            }
        },
        getMyMessage() {
            if (!this.userDetail) return []
            if (this.messageList.length === 0) {
                return []
            }
            if (this.messageList.length > 0) {
                return this.messageList.filter(item =>{
                    return (parseInt(item.u_id) == parseInt(this.userDetail.id))
                })
            }
        },
        autoResizeTextArea() {
            const textarea = document.querySelector("#chatInput");

            textarea.addEventListener('input', () => {
                textarea.style.height = 'auto';
                textarea.style.height = textarea.scrollHeight + 'px';;
            }, false);
        },
        closeSubscription() {
            this.setFooter(false)
            document.getElementById('subscription').classList.remove('show-right')
            document.getElementById('subscription').classList.add('hidden-right')
        },
        openSubscription() {
            this.isShowAlertSubscription = false
            document.getElementById('subscription').classList.add('show-right')
            document.getElementById('subscription').classList.remove('hidden-right')
        },
        openVerifyAge() {
            this.isShowAlertVerifyAge = false
            document.getElementById('very-age').classList.add('show-right')
            document.getElementById('very-age').classList.remove('hidden-right')
        },
        closeVerifyAge(val) {
            this.setFooter(false)
            if (val) {
                this.userDetail.is_verify_age = CONSTANTS.PC_VERY_AGE
            }
            document.getElementById('very-age').classList.remove('show-right')
            document.getElementById('very-age').classList.add('hidden-right')
        },
        outSideClick() {
            document.addEventListener("click", (evt) => {
            const flyoutElement = document.getElementsByClassName("subscription")[0];
            let targetElement = evt.target; // clicked element
            do {
                if (targetElement == flyoutElement) {
                    return;
                }
                // Go up the DOM
                targetElement = targetElement.parentNode;
                // targetElement.getElementsByTagName('img')[0].src = document.getElementById('main_avatar').getElementsByTagName('img')[0].src;
            } while (targetElement);
            const wrap = document.querySelector(".wrap");
            if (wrap == evt.target) {
                this.isShowAlertSubscription = false
                this.isShowAlertVerifyAge = false
            }
            // This is a click outside.
        });
        }
    },
};
</script>

<style scoped>
.vue-map-container {
    width: 100%;
    height: 100%;
}
.flex-row {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.flex-row button {
    outline: none;
    border: none;
    color: #4a87fb;
    width: 100%;
    background: #fff;
    padding: 10px;
    border-bottom: 1px solid #e0e0e0;
}

.flex-row button.btn-start {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
}

.flex-row button.btn-end {
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
}

.flex-row button.btn-close {
    margin-top: 15px;
    border-radius: 5px;
}
.favorite-message {
    color: #777;
    background: #fff;
    border-radius: 5px;
    padding: 5px;
}
.alert-first-message {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.btn-submit {
    background: #64c9d1;
    color: #fff;
    border: none;
    outline: none;
    border-radius: 5px;
    width: 93px;
    height: 34px;
}
.btn-disable {
    background: #b4b4b4;
    color: #fff;
    border: none;
    outline: none;
    border-radius: 5px;
    width: 93px;
    height: 34px;
}
.message-action {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10px;
}
.message-action a {
    display: flex;
    justify-content: center;
    align-items: center;
}
.message-action textarea {
    margin: 0px;
    margin-left: 5px;
    margin-right: 5px !important;
}
 .hidden-user {
  right: -100%;
  overflow: hidden;
}
.show-user {
  right: 0;
  overflow: unset;
}
#detail {
  transition: all 0.2s;
  /* top: 0; */
  /* position: fixed; */
  width: 100%;
}
.vertical-center {
    margin: 0;
    position: absolute;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
}
.mycomment p {
    word-break: break-word;
    text-align: left;
    font-weight: 400;
}
.mycomment {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
    margin-left: 20%;
}
.mycomment span, .mycomment p, .alert-first-message {
    color: #000;
    font-weight: 400;
}
.balloon .chatting {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
}
.chat-bc {
    padding-bottom: 100px;
}
.chatting .says {
    font-weight: 400;
}
.chat-bc span {
    color: #060606;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-left: 36px;
    font-weight: 400;
}
.chat5 li {
    border-bottom: 3px solid #f9f9f9;
    border-right: 3px solid #f9f9f9;
}
.chat-time2, .chat-time {
    font-weight: 400;
}
.subscription {
    background: #fff;
    padding-bottom: 10px;
}
.subscription .content {
    padding: 20px;
}
.subscription .btn1 {
    color: #fff;
    padding: 10px;
}
.hidden-right {
    position: fixed;
    right: -100%;
    top: 0;
    width: 100%;
    overflow: hidden;
}
.show-right {
    position: absolute;
    right: 0;
    top: 0;
    width: 100%;
    overflow: hidden;
    z-index: 999999;
    background: #fff;
    overflow: scroll;
    height: 100vh;
}
#subscription, #very-age {
    transition: all 0.2s;
}
.alert {
    right: 5%;
}
.message .content {
    font-weight: 400;
}
</style>
